import React from 'react';

const Header = () => {
    return (
        <a href='https://open.spotify.com/genre/new-releases-page' rel="noopener noreferrer"><h1>New albums & singles</h1></a>
)}

export default Header;